import Media from "@/prototype/utils/Media.js";
import Error from "@/prototype/utils/Error.js";

import global   from "@/prototype/global.js";

const log = global.log.getLogger("f_mtac.storage.space.media_index");
log.setLevel(log.levels.WARN);

import PQueue from "p-queue/dist/index.js";

const MEDIA_CREATE = 11;
const MEDIA_DELETE = 12;
const MEDIA_IGNORE = 13;
// changeset state
const CHANGESET_PENDING = 21;
const CHANGESET_WAITING = 22;
const CHANGESET_PUSHED  = 23;

let changeset_prototype = {
    store: function() {
        this.method = MEDIA_CREATE;
    },
    delete : function() {
        if (this.method === MEDIA_CREATE) {
            this.method = MEDIA_IGNORE;
            return;
        }
        this.method = MEDIA_DELETE;
    }
};

let Changeset = function(local_id) {
    this.method = null;
    this.state = CHANGESET_PENDING;
    this.media = null;
    this.media_hash = null;
    this.media_data = null;
    Object.defineProperty(this, "local_id", {
        set: () => {},
        get: () => local_id
    });
};
Object.assign(Changeset.prototype, changeset_prototype);

let Store = function(space) {
    var pending = Object();
    var room = undefined;

    Object.defineProperty(this, "room", {
        set: (new_room) => {
            if (new_room === null) {
                room = null;
                return;
            }
            room = new_room;
        },
        get: () => room
    });

    this.init = async (new_room) => {
        
        // in case of server restart, need to re-commit everything on the same room
        //let old_room = room;
        /*if (String(old_room) === String(new_room)) {
            return;
        }*/
        pending = Object();
        room = new_room;
        let medias = await space.media_retrieve({});
        medias.each(media => this.commit(media));
    };

    this.deinit = () => {
        pending = Object();
        room = null;
        return Promise.resolve();
    };

    this.commit = ({local_id, media_data, media_hash}) => {
        var changeset = null;
        if (local_id in pending) {
            changeset = pending[local_id];
        } else {
            changeset = new Changeset(local_id);
            pending[local_id] = changeset;
        }
        if (media_hash !== undefined){
            changeset.media_hash = media_hash;
        }
        if (media_data !== undefined){
            changeset.media_data = media_data;
        }
        if (media_data !== null) {
            changeset.store();
        } else {
            changeset.delete();
        }
        if (changeset.method === MEDIA_IGNORE) {
            delete pending[local_id];
        }
        return changeset;
    };

    const rx_tx_queue = new PQueue({concurrency: 1});

    const push = async () => {
        if (room === null) {
            return;
        }

        let changesets = [];
        for (let local_id in pending) {
            let changeset = pending[local_id];
            if (changeset.state !== CHANGESET_PENDING) {
                continue;
            }
            changeset.state = CHANGESET_WAITING;
            changesets.push(changeset);
        }

        try {
            for (let changeset of changesets) {
                if (changeset.method === MEDIA_CREATE) {
                    let media = await space.media_retrieve({local_id: changeset.local_id});
                    changeset.media = media;
                    changeset.media_hash = media.media_hash;
                    changeset.media_data = media.media_data;
                    await global.server.mtac_media_create({
                        space: room.space,
                        media_hash: changeset.media_hash,
                        media_data: changeset.media_data
                    });
                } else if (changeset.method === MEDIA_DELETE) {
                    /*let media_used = 0;
                    for (let current_context of global.storage.selected_space.context) {
                        if (current_context === null) {
                            continue;
                        }
                        let media_objects = current_context.objects.where("object_data.attributes.dataMedia").equals(changeset.local_id);
                        await media_objects.each(()=>{
                            media_used++;
                        });
                    }
                    if (media_used > 0){
                        log.warn(`discarding global.server.mtac_media_delete request of ${changeset.media_hash}`);
                    } else {*/
                    // control of media used done before commit
                    await global.server.mtac_media_delete({
                        space: room.space,
                        media_hash: changeset.media_hash
                    });
                    // }
                }
                changeset.state = CHANGESET_PUSHED;
                delete pending[changeset.local_id];
            }
        } catch(error) {
            for (let changeset of changesets) {
                if (changeset.state === CHANGESET_PUSHED) {
                    continue;
                }
                changeset.state = CHANGESET_PENDING;
                switch(changeset.method) {
                case MEDIA_CREATE:
                    if (!global.server.uploadingCancelled){
                        log.error(`failed to create new media ${JSON.stringify(changeset.local_id)} on server, will continue trying`);
                    }
                    changeset.media = null;
                    break;
                case MEDIA_DELETE:
                    log.error(`failed to delete media ${JSON.stringify(changeset.local_id)} on server, will continue trying`);
                    break;
                }
                switch(error.status) {
                case Error.status.netdown:
                case Error.status.hostdown:
                    continue;
                case Error.status.access:
                    global.storage.unshare({});
                    return;
                case Error.status.invalid:
                    delete pending[changeset.local_id];
                    throw error; // so that associated object should not be created
                case Error.status.canceled: // AGPOC-9068 : create media cancelled by user => do not retry
                    delete pending[changeset.local_id];
                    throw error; // so that associated object should not be created
                default:
                    log.error("failed to handle media error, will try again next time", error);
                    continue;
                }
            }
        }
    };

    this.push = () => rx_tx_queue.add(() => push());

    const pull = async () => {
        if (room === null) {
            return;
        }

        let handle_network_error = (error) => {
            switch(error.status) {
            case Error.status.netdown:
            case Error.status.hostdown:
                return;
            case Error.status.access:
                global.storage.unshare({});
                return;
            default:
                log.error("failed to handle object pull error, will try again next time", error);
                return;
            }
        };

        try {
            var remote = await global.server.mtac_media_list(room).then(({data}) => {
                let {list, media_total_size, media_max_total_size} = data;
                return {medias: list, media_total_size, media_max_total_size};
            });
        } catch (error) {
            switch(error.status) {
            case Error.status.noent:
                log.error(`unable to list medias, room space ${room.space} doesn't exist`);
                return;
            default:
                return handle_network_error(error);
            }
        }
        //log.error("remote medias =",remote.medias);
        let local_medias = await space.media_retrieve({});
        let local_media_ids = await local_medias.primaryKeys();
        for (let remote_media of remote.medias) {
            let local_media_index = local_media_ids.indexOf(`media-${remote_media.hash}`);
            if (local_media_index !== -1) {
                local_media_ids.splice(local_media_index, 1);
                continue;
            }
            try {
                remote_media.blob = await global.server.mtac_media_retrieve({
                    space: room.space,
                    hash: remote_media.hash
                });
            } catch(error) {
                return handle_network_error(error);
            }
            let local_media = await Media.binary_to_media(remote_media.blob, false);
            local_media.media_hash = remote_media.hash;
            await space.media_create(local_media);
            delete remote_media.blob;
        }

        // log.warn("probably (?) unused media in database", local_media_ids);
        for (let local_id of local_media_ids){
            let media_used = 0;
            for (let current_context of global.storage.selected_space.context) {
                if (current_context === null) {
                    continue;
                }
                let media_objects = current_context.objects.where("object_data.attributes.dataMedia").equals(local_id);
                await media_objects.each(()=>{
                    media_used++;
                });
            }
            if (media_used > 0){
                continue;
            } else {
                await space.media_retrieve({local_id}).modify((media, ref) => {
                    global.server.mtac_media_delete({
                        space: room.space,
                        media_hash: media.media_hash
                    });
                    delete ref.value;
                });
            }
        }
        
        /*
        // to be secured
        for (let local_media_id of local_media_ids) {
            if (local_media_id in pending) {
                continue;
            }
            await space.media_delete({local_id: local_media_id});
        }
        */
    };

    this.pull = () => rx_tx_queue.add(() => pull());
};

export default Store;
